import { FolderShare } from "./useQueryFolderShares";

export function getMemberIdsFromShares(shares: FolderShare[]) {
  return shares
    .filter(
      (share) =>
        share.shareType === "customuser" || share.shareType === "owner",
    )
    .map((share) => share.shareId);
}
